import { LinesetLevel } from '@alpinehomeair/common';
import { LevelType } from 'data/types';

function attributeValue(level: LevelType, code: string): string | undefined {
  const attribute = level.attributes.find((item) => item.code === code);
  return attribute?.value != null ? String(attribute.value) : undefined;
}

export function toLinesetLevel(
  level: LevelType | undefined
): LinesetLevel | undefined {
  if (!level) return undefined;
  const ceiling = Number(attributeValue(level, 'ceiling_height'));
  return {
    uniqueId: level.uniqueId,
    type: level.type,
    conditioned: level.conditioned,
    ceilingHeightFeet:
      Number.isFinite(ceiling) && ceiling > 0 ? ceiling : undefined,
    heating: attributeValue(level, 'heating') ?? null,
    cooling: attributeValue(level, 'cooling') ?? null,
    footprint: level.footprint ?? null,
    footprintShapes: level.footprintShapes ?? null
  };
}

export function toLinesetLevels(structure: LevelType[]): LinesetLevel[] {
  return structure.flatMap((level) => {
    const mapped = toLinesetLevel(level);
    return mapped ? [mapped] : [];
  });
}
